module.exports = __webpack_public_path__ + "static/media/main.4765938e.jpg";